<div class="vc-modal__innerContainer conditionGuideModal">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>
  <div class="vc-modal__title conditionGuideModal__title" i18n="@@CONDITION_GUIDE.MODAL.TITLE">Product condition</div>
  <vc-condition-guide
    *ngFor="let condition of conditions; let first = first; index as i"
    class="condition"
    [conditionName]="condition.name"
    [goodCondition]="condition.good"
    [badCondition]="condition.bad"
    [id]="i"
  ></vc-condition-guide>
</div>
